import { EnumType } from '@/pages/Partners/types/paths';

import textsJSON from './texts.json';

export enum ENUMPropertyType {
  apartment = 'Apartment',
  house = 'House',
  hotel = 'Hotel',
  inn = 'Inn',
  entireBuilding = 'Entire Building',
  spot = 'Spot',
  launch = 'Launch',
  views = 'Views',
  studio = 'Studio',
}

export const typeOptions = [
  {
    id: 1,
    value: ENUMPropertyType.apartment,
    valueLabel: 'Apartamento',
  },
  {
    id: 2,
    value: ENUMPropertyType.house,
    valueLabel: 'Casa',
  },
  {
    id: 3,
    value: ENUMPropertyType.hotel,
    valueLabel: 'Hotel',
  },
  {
    id: 4,
    value: ENUMPropertyType.inn,
    valueLabel: 'Pousada',
  },
  {
    id: 5,
    value: ENUMPropertyType.entireBuilding,
    valueLabel: 'Prédio Inteiro',
  },
  {
    id: 6,
    value: ENUMPropertyType.spot,
    valueLabel: 'SPOT',
  },
  {
    id: 7,
    value: ENUMPropertyType.launch,
    valueLabel: 'Lançamento',
  },
  {
    id: 8,
    value: ENUMPropertyType.views,
    valueLabel: 'Vistas',
  },
  {
    id: 9,
    value: ENUMPropertyType.studio,
    valueLabel: 'Studio',
  },
];

export interface ITexts {
  headerTitle: string;
  headerDescription: string;
}

export const initialText: ITexts = textsJSON.default;

export function validateText(type: string | undefined): ITexts {
  // type is IType
  switch (type) {
    case EnumType.terrain:
      return textsJSON.terrain;
    case EnumType.location:
      return textsJSON.location;
    case EnumType.spot:
      return textsJSON.spot;
    case EnumType.builder:
      return textsJSON.builder;
    case EnumType.marketplace:
      return textsJSON.marketplace;
    case EnumType.partner:
      return (textsJSON as any).partner;
    case EnumType.franchise:
      return (textsJSON as any).franchise;
    case EnumType.decor:
      return (textsJSON as any).decoracao;
    default:
      return textsJSON.default as any;
  }
}
